import stringify from 'json-stringify-safe';

import { SentryService } from 'services/sentry';

import { isString } from 'utils/functions';

type LogArgs = Parameters<typeof console.log>;
type WarnArgs = Parameters<typeof console.warn>;

export class Logger {
  private static isDebugMode(): boolean {
    if (typeof window === 'undefined') {
      return false;
    }

    const params = new URLSearchParams(window.location.search);
    return params.get('debug') !== null;
  }

  static log(...args: LogArgs): void {
    if (Logger.isDebugMode()) {
      console.log(...args);
    }
  }

  static warn(...args: WarnArgs): void {
    if (Logger.isDebugMode()) {
      console.warn(...args);
    }
  }

  static error(message: string, ...args: any[]): void {
    if (Logger.isDebugMode()) {
      console.error(...args);
    }

    const serializedArgs = args.map((arg) => {
      if (isString(arg) || arg instanceof Error) {
        return arg;
      }

      return stringify(arg);
    });

    SentryService.captureError({ message, context: serializedArgs });
  }
}
